import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icone, type NomIcone } from '../../../composants/icones.tsx';
import { useSession } from '../../../composants/session.tsx';

const ACTIONS: {
  vers: string;
  libelle: string;
  detail: string;
  icone: NomIcone;
  permission: string;
}[] = [
  {
    vers: '/produits',
    libelle: 'Ajouter un article',
    detail: 'Nouvelle fiche au catalogue',
    icone: 'produits',
    permission: 'produit.creer',
  },
  {
    vers: '/receptions',
    libelle: 'Réceptionner',
    detail: 'Entrée de marchandise',
    icone: 'fournisseurs',
    permission: 'stock.lire',
  },
  {
    vers: '/resultats',
    libelle: 'Voir les chiffres',
    detail: 'CA et marge par boutique',
    icone: 'resultats',
    permission: 'rapport.ca.lire',
  },
  {
    vers: '/clients',
    libelle: 'Suivre les crédits',
    detail: 'Soldes et règlements',
    icone: 'clients',
    permission: 'client.lire',
  },
];

/**
 * Raccourcis vers les gestes fréquents — une LISTE sobre, pas des tuiles
 * colorées : elles ne rivalisent plus avec le ticket du jour pour
 * l'attention. Des BOUTONS, pas des liens : les mêmes destinations existent
 * déjà dans le rail, et deux liens au même nom rendraient la navigation
 * ambiguë pour un lecteur d'écran. Chaque action est filtrée par permission.
 */
export function BlocActions(): ReactNode {
  const { peut } = useSession();
  const naviguer = useNavigate();
  const visibles = ACTIONS.filter((action) => peut(action.permission));

  if (visibles.length === 0) return null;

  return (
    <div className="tdb-actions">
      {visibles.map((action) => (
        <button
          key={action.vers}
          type="button"
          className="tdb-action"
          onClick={() => void naviguer(action.vers)}
        >
          <Icone nom={action.icone} taille={20} />
          <strong>{action.libelle}</strong>
          <span>{action.detail}</span>
        </button>
      ))}
    </div>
  );
}
